import { fetchJSONWithTimeout, isBrowser } from '@noths/polaris-client-utils';
import getConfig from 'next/config';

import type { NextConfig } from 'src/types/nextConfig';
import { logger } from 'src/utils/serverLogger';

const { publicRuntimeConfig } = getConfig() as NextConfig;

export const TIMEOUT = {
  server: 5500,
  browser: 15000,
};

const getTimeout = () => (isBrowser() ? TIMEOUT.browser : TIMEOUT.server);

const url = new URL(`${publicRuntimeConfig.endpoints.listings}v1/listings`);

const requestUrl = url.toString();
interface FetchBrowseDataArgs {
  searchTerm?: string;
  userId?: string;
}
export const fetchListingsData = async ({ searchTerm, userId }: FetchBrowseDataArgs) => {
  const apiResponse = (await fetchJSONWithTimeout(requestUrl, {
    method: 'POST',
    credentials: 'include',
    redirect: 'manual',
    timeout: getTimeout(),
    headers: {
      'noths-visitor-id': userId || '',
      'Content-Type': 'application/json',
    },
    body: {
      facetSpecs: [],
      searchTerm: searchTerm,
      pageSize: 5,
      offset: 1,
    },
  })) as Response;

  const { status, statusText } = apiResponse;

  switch (status) {
    case 201: {
      const data = await apiResponse.json();

      return { data };
    }
    case 400: {
      logger.warn(`${statusText}`, { requestUrl });
      return null;
    }
    case 500: {
      logger.warn(`${statusText}`, { requestUrl });
      return null;
    }
    default: {
      const { errorCode, errorMessage } = await apiResponse.json();

      logger.error('error fetching data from listings-api', {
        requestUrl,
        status,
        errorCode,
        errorMessage,
      });

      throw new Error(`error fetching data from listings-api`);
    }
  }
};
